import { twMerge } from '@shared/themes';
import type { ComponentProps } from 'react';
import type { PrizeTableTooltips, TableRowProps } from '../../../../types';
import { Row } from './components';

type TableProps = ComponentProps<'table'> & {
  headers: TableRowProps['headers'];
  data: TableRowProps['row'][];
  disableFirstRow?: boolean;
  tooltips?: PrizeTableTooltips;
};

function Table({ headers, data, className, disableFirstRow = false, tooltips, ...props }: TableProps) {
  return (
    <table className={twMerge('w-full border-collapse border-spacing-0', className)} {...props}>
      <thead>
        <Row headers={headers} rowIndex={0} />
      </thead>
      <tbody>
        {data.map((row, index) => (
          <Row
            key={index}
            headers={headers}
            rowIndex={index}
            data={row}
            className={disableFirstRow && index === 0 ? 'opacity-40' : ''}
            aria-disabled={disableFirstRow && index === 0}
            tooltips={tooltips?.get(index)}
          />
        ))}
      </tbody>
    </table>
  );
}

export { Table };
